<mobi-breadcrumb />
<mobi-ld-schema [schema]="jsonLdData()" />
<div class="overflow-hidden guide-hero mobi-ui-margin-b-lg">
  <div
    class="hero-wrapper mobi-ui-grid justify-end md:flex-row-reverse mobi-ui-margin-t-sm mobi-ui-margin-b-xxl"
  >
    <div
      class="mobi-ui-col-1/1 md:mobi-ui-col-7/16 lg:mobi-ui-col-5/12 lg:mobi-ui-offset-1/12 xl:mobi-ui-col-5/16 xl:mobi-ui-offset-1/16"
    >
      @if (entity().headerImage) {
        <div class="hero-image-animation-wrapper">
          <mobi-media
            [animation]="false"
            class="mobi-ui-animation-appear-left-init mobi-ui-animation-appear-left-render is-delayed-300"
            [entity]="entity().headerImage"
            [responsiveStyle]="breakpoint.smMax() ? 'hero_single' : 'hero_3_4'"
            [lazy]="false"
          />
        </div>
      }
    </div>
    <div
      class="mobi-ui-col-1/1 md:mobi-ui-col-9/16 lg:mobi-ui-col-6/12 xl:mobi-ui-col-6/16 xl:mobi-ui-offset-2/16"
    >
      <mobi-hero-text
        [superTitle]="entity().superTitle"
        [title]="entity().title"
        [subtitle]="entity().subtitle"
        [lead]="entity().lead"
        [contentLinks]="entity().summary?.text ? undefined : contentLinks()"
        [fullWidth]="true"
      />
    </div>
  </div>
  <!-- add meta-info -->
  @if (entity().authors || formattedLastUpdated() || entity().nodeReadTime) {
    @defer (hydrate on viewport) {
      <mobi-meta-info
        [authors]="entity().authors"
        [lastUpdated]="formattedLastUpdated()"
        [readingTime]="entity().nodeReadTime || ''"
        [hasBorderBottom]="true"
        [date]="entity().created"
        [nid]="entity().id"
      />
    }
  }

  @if (entity().quickHelp) {
    <div class="mobi-ui-grid is-centered guide-help no-heading-spacing">
      <div class="mobi-ui-col-1/1 xl:mobi-ui-col-3/4">
        <section
          class="mobi-ui-section-minor mobi-ui-section-illustration-wrapper-minor !bg-[#FAFAFA] !mx-0 mobi-ui-margin-t-xxxl smMax:!pt-9 md:!pb-[calc(12*(var(--mobi-ui-scale-unit)))]"
        >
          <mobi-ui-illustration-major
            class="mobi-ui-section-illustration-minor is-left"
            [illustration]="{ name: '', symbol: 'basic_access_smartphone_app' }"
          />
          <h2 class="mobi-ui-font-h3 !pb-4 md:!pb-0">{{ entity().quickHelp!.title }}</h2>
          <mobi-text class="mobi-ui-font-size-150" [data]="entity().quickHelp!.text" />
        </section>
      </div>
    </div>
  }

  @if (entity()?.summary?.text) {
    <div class="mobi-ui-grid is-centered guide-summary">
      <div class="mobi-ui-col-1/1 xl:mobi-ui-col-3/4">
        <div class="mobi-ui-ink-blue scroll-pt-12">
          <section
            class="mobi-ui-section-minor mobi-ui-section-illustration-wrapper-minor mobi-ui-ink-blue !mx-0"
          >
            @defer (hydrate never) {
              <mobi-ui-illustration-major
                class="mobi-ui-section-illustration-minor is-left"
                [illustration]="{ name: '', symbol: 'signpost_blue' }"
              ></mobi-ui-illustration-major>
            }
            <h4 class="mobi-ui-font-h2 mobi-ui-text-inked">
              {{
                'in_a_nutshell'
                  | texts: { context: 'frontend', default: 'Das Wichtigste in Kürze' }
              }}
            </h4>
            <mobi-text
              class="big-leading"
              [data]="entity().summary?.text ?? ''"
            ></mobi-text>
            @if (contentLinks() && (contentLinks()?.length ?? 0) > 0) {
              <span class="font-bold text-[#007B91]">
                {{
                  'on_this_page'
                    | texts: { context: 'frontend', default: 'Auf dieser Seite' }
                }}
              </span>
              <div class="text-animation mobi-ui-padding-t-xs">
                <mobi-content-links [contentLinks]="contentLinks() ?? []" />
              </div>
            }
          </section>
        </div>
      </div>
    </div>
  }
</div>
<div #startSticky class="h-0"></div>
<div class="relative">
  <div class="page-content mobi-ui-ink-blue">
    @if (entity().paragraphs) {
      @for (paragraph of entity().paragraphs; track paragraph?.uuid ?? $index) {
        @if (paragraph) {
          <mobi-paragraph-loader
            [bundle]="paragraph.type"
            [data]="{ paragraph: paragraph }"
          />
        }
      }
    }
    <div #endSticky class="h-0"></div>
    <div
      class="transform-gpu left-0 right-0 bottom-0 z-10"
      [class]="{
        fixed: !isRatingBarDismissed() && sticky(),
        'mobi-ui-container': !isRatingBarDismissed() && sticky(),
        'bottom-[80px]': hasSticky(),
        'md:bottom-0': hasSticky(),
      }"
    >
      <div
        class="mobi-ui-grid !flex-nowrap is-centered is-align-center mobi-ui-section-minor mobi-ui-margin-b-md !px-0 relative"
      >
        @if (breakpoint.smMax() && sticky()) {
          <button
            class="absolute w-8 h-8 rounded-full flex items-center justify-center text-signature bg-bg-2 -top-2 -left-1 z-[10]"
            (click)="isRatingBarDismissed.set(true)"
            aria-label="Dismiss rating bar"
          >
            <mobi-ui-icon-major name="the_x" class="!p-0 pointer-events-none" />
          </button>
        }
        <span
          class="mobi-ui-font-bold md:mobi-ui-col-1/2 flex justify-center md:justify-end guide-rating-label-md-max mdMax:w-auto mdMax:basis-[auto]"
        >
          {{
            'rating_text'
              | texts
                : {
                    context: 'frontend',
                    default: 'War dieser Ratgeber hilfreich für Sie?',
                  }
          }}
        </span>
        @defer (on idle) {
          <div
            class="flex justify-center md:justify-start md:mobi-ui-col-1/2 mdMax:w-auto mdMax:basis-[auto]"
          >
            <mobi-rating [nid]="entity().id" />
          </div>
        }
      </div>
    </div>

    @defer (hydrate on viewport) {
      @if (entity().relatedContent?.length) {
        <div class="content-section is-background">
          <div>
            <mobi-related-content
              [teasers]="entity().relatedContent!"
              [title]="entity().relatedContentTitle"
              [description]="entity().relatedContentText"
              [topicLink]="entity().relatedContentTopic"
            />
          </div>
        </div>
      }
    }
  </div>
</div>
